export async function getFileBuffer(file) {
	return new Promise((resolve) => {
		const reader = new FileReader();
		reader.onload = (e) => {
			const arrayBuffer = e.target.result;
			resolve(arrayBuffer);
		};
		reader.onerror = (e) => {
			console.error('FileReaderError: ', e);
		};
		reader.readAsArrayBuffer(file);
	});
}

export async function dataUrlToFile(dataUrl, fileName) {
	const res = await fetch(dataUrl);
	const blob = await res.blob();
	return new File([blob], fileName, { type: dataUrl.match(/^data:(.+);base64/)?.[1] });
}

export async function base64ToFile(base64String, fileName, mimeType) {
	const dataUrl = `data:${mimeType};base64,${base64String}`;
	const res = await fetch(dataUrl);
	const blob = await res.blob();
	return new File([blob], fileName, { type: mimeType });
}